export const areCustomerBillsEnabled = () => {
  return true;
};
